export const GET_CONFIG = 'get.config';

export type ServiceConfigManagerQueries = {
    [GET_CONFIG]: string[];
};
export type ServiceConfigManagerQueriesResponseType = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [GET_CONFIG]: Promise<{ [key: string]: any }>;
};
